import { AspectKindType } from '@prophecy/graphql-types/enums';
import { parseJSON } from '@prophecy/utils/string';

import { Aspect, VersionedAspect } from '../../queries/common';

export const getVersionAspectValue = (aspectType: AspectKindType, aspects: VersionedAspect[]) => {
  const currentAspect = aspects.find((a) => a.VersionedAspectName === aspectType);
  const aspectValue = currentAspect?.VersionedAspectValue;
  return aspectValue;
};

export const versionedAspectPathResolver = (
  aspectType: AspectKindType,
  aspects: VersionedAspect[],
  propertyName?: string
) => {
  const aspectValue = getVersionAspectValue(aspectType, aspects);
  const parsedData = aspectValue ? JSON.parse(aspectValue) : {};
  return propertyName ? parsedData[propertyName] : parsedData;
};

export function getAspectValue<T>(aspect?: Aspect<T>[]) {
  return parseJSON<T | null>(aspect?.[0]?.AspectValue, null);
}
